module.exports = __webpack_public_path__ + "static/media/mc-columns-cloud-1.c914babd.svg";